export type OfertasCarrinho = {
  enabled: boolean;
  type: 'CATEGORY' | 'PRODUCT';
  categoryIds: string[];
  productIds: string[];
  maxItems: number;
  selectionStrategy: 'CATALOG_ORDER';
  skipCategoryIfAlreadyInCart: boolean;
};

export const categoriaReferencia = (categoria: any): string => String(categoria?.id || categoria?.nome || '');

const resolverProdutoReferenciado = (ref: string, produtos: any[]): any => {
  const encontrados = produtos.filter(produto => produto.id && produto.id === ref);
  return encontrados.length === 1 ? encontrados[0] : undefined;
};

export function normalizarOfertasCarrinho(value?: Partial<OfertasCarrinho> | null): OfertasCarrinho {
  return {
    enabled: value?.enabled === true,
    type: value?.type === 'PRODUCT' ? 'PRODUCT' : 'CATEGORY',
    categoryIds: Array.isArray(value?.categoryIds) ? [...value!.categoryIds] : [],
    productIds: Array.isArray(value?.productIds) ? [...value!.productIds] : [],
    maxItems: Math.max(1, Math.min(3, Math.trunc(Number(value?.maxItems) || 3))),
    selectionStrategy: 'CATALOG_ORDER',
    skipCategoryIfAlreadyInCart: value?.skipCategoryIfAlreadyInCart !== false,
  };
}

export function normalizarCategoriasReferenciadas(refs: string[], categorias: any[]): string[] {
  return Array.from(new Set((refs || []).map(ref => {
    const categoria = categorias.find(cat => cat.id === ref || cat.nome === ref);
    return categoria ? categoriaReferencia(categoria) : ref;
  })));
}

export function prepararOfertasCarrinho(value: OfertasCarrinho, categorias: any[], produtos: any[], origemId?: string): OfertasCarrinho {
  const regra = normalizarOfertasCarrinho(value);
  const referencias = new Set(categorias.map(categoriaReferencia));
  const produtosValidos = produtos.filter(p => p.id && p.tipo !== 'complementos' && p.id !== origemId);
  return {
    ...regra,
    categoryIds: regra.type === 'CATEGORY'
      ? normalizarCategoriasReferenciadas(regra.categoryIds, categorias).filter(ref => referencias.has(ref)) : [],
    productIds: regra.type === 'PRODUCT'
      ? Array.from(new Set(regra.productIds.map(ref => resolverProdutoReferenciado(ref, produtosValidos))
        .filter(Boolean).map(produto => produto.id))) : [],
  };
}

export function resumoOfertasCarrinho(regra: OfertasCarrinho, categorias: any[], produtos: any[]): string {
  const referencias = regra.type === 'CATEGORY' ? regra.categoryIds : regra.productIds;
  return referencias.map(ref => {
    const item = regra.type === 'CATEGORY'
      ? categorias.find(cat => cat.id === ref || cat.nome === ref)
      : resolverProdutoReferenciado(ref, produtos);
    return item?.nome || 'Item indisponível';
  }).join(', ');
}

/** Uma cópia possui novas opções; IDs de produtos vinculados permanecem. */
export function duplicarComplementos(grupos: any): any[] {
  return (Array.isArray(grupos) ? grupos : []).map((grupo: any) => {
    const { id, ...copiaGrupo } = grupo;
    return {
      ...copiaGrupo,
      itens: (grupo.itens || []).map((item: any) => {
        const { optionId, ...copiaItem } = item;
        return { ...copiaItem };
      }),
    };
  });
}
